/* [PATCH dc-dodatki v1] Delovni čas: dodatki zaposlenemu (stimulacija + vrste podjetja), stalni ali za mesec, in nadure.
   DodatkiMeseca — v »Moj mesec« (admin ureja, zaposleni samo vidi); StalniDodatki — v Šifranti → Zaposleni (samo admin).
   API: /kadri/{cid}/dodatki (POST), /dodatki/{id} (DELETE), /dodatki/vrste (GET, POST), /zaposleni/{zid}/dodatki (GET),
        /mesec/nadure (POST) — backend api/kadri.py. */
import React, { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

const napaka = (e: any) => e?.response?.data?.detail
  ? (typeof e.response.data.detail === 'string' ? e.response.data.detail : JSON.stringify(e.response.data.detail))
  : (e?.message || 'Napaka');
const kartica = 'bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-700 p-4';
const gumb = 'px-4 py-2 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50';
const gumb2 = 'px-3 py-2 rounded-lg text-sm font-medium border border-gray-200 dark:border-gray-700 hover:border-blue-400 bg-white dark:bg-gray-900';
const polje = 'px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-sm';
const MESECI = ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december'];
const st = (s: any) => Number(s || 0).toLocaleString('sl-SI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function Sporocilo({ msg }: { msg: { tip: 'ok' | 'napaka'; t: string } | null }) {
  if (!msg) return null;
  return <div className={'px-3 py-2 rounded-lg border text-sm ' + (msg.tip === 'ok' ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200')}>{msg.t}</div>;
}

/* Obrazec za nov dodatek; »+ nova vrsta …« v izbirniku doda vrsto podjetja (pojavi se v prevajalni tabeli). */
function DodatekObrazec({ cid, zaposleniId, leto, mesec, samoStalni, onShranjeno }:
  { cid: string; zaposleniId: string; leto?: number; mesec?: number; samoStalni: boolean; onShranjeno: () => void }) {
  const [vrste, setVrste] = useState<any[]>([]);
  const [f, setF] = useState<any>({ vrsta: 'STIMULACIJA', znesek: '', stalni: samoStalni, opomba: '' });
  const [nova, setNova] = useState<string | null>(null);
  const [msg, setMsg] = useState<{ tip: 'ok' | 'napaka'; t: string } | null>(null);
  const [dela, setDela] = useState(false);
  const naloziVrste = useCallback(() => {
    api.get(`/kadri/${cid}/dodatki/vrste`).then((r: any) => setVrste(r.data)).catch((e: any) => setMsg({ tip: 'napaka', t: napaka(e) }));
  }, [cid]);
  useEffect(() => { naloziVrste(); }, [naloziVrste]);

  const dodajVrsto = async () => {
    setMsg(null);
    try {
      const r = await api.post(`/kadri/${cid}/dodatki/vrste`, { naziv: nova || '' });
      setVrste((v: any[]) => [...v, r.data]); setF({ ...f, vrsta: r.data.kljuc }); setNova(null);
      setMsg({ tip: 'ok', t: `Vrsta »${r.data.naziv}« dodana — v Vrstah plačil ji določi šifro.` });
    } catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); }
  };
  const shrani = async () => {
    setMsg(null); setDela(true);
    try {
      await api.post(`/kadri/${cid}/dodatki`, { zaposleni_id: zaposleniId, vrsta: f.vrsta, znesek: String(f.znesek || '').replace(',', '.'),
        stalni: samoStalni || !!f.stalni, leto, mesec, opomba: f.opomba || null });
      setF({ ...f, znesek: '', opomba: '' }); onShranjeno();
    } catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); } finally { setDela(false); }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-end gap-2 flex-wrap">
        <label className="text-xs text-gray-500 block">Vrsta
          {nova === null
            ? <select className={polje + ' block'} value={f.vrsta} onChange={e => { if (e.target.value === '__nova') setNova(''); else setF({ ...f, vrsta: e.target.value }); }}>
                {vrste.map((v: any) => <option key={v.kljuc} value={v.kljuc}>{v.naziv}</option>)}
                <option value="__nova">+ nova vrsta …</option></select>
            : <span className="flex items-center gap-1">
                <input className={polje} autoFocus placeholder="npr. Dodatek" value={nova} onChange={e => setNova(e.target.value)} />
                <button type="button" className={gumb2} onClick={dodajVrsto}>Dodaj vrsto</button>
                <button type="button" className="text-sm text-gray-500 hover:underline" onClick={() => setNova(null)}>Prekliči</button></span>}
        </label>
        <label className="text-xs text-gray-500 block">{vrste.find((v: any) => v.kljuc === f.vrsta)?.enota === 'h' ? 'Ure' : 'Znesek'}{/* [PATCH dc-opal-fe v1] */}
          <input className={polje + ' block w-32'} inputMode="decimal" value={f.znesek} onChange={e => setF({ ...f, znesek: e.target.value })} /></label>
        <label className="text-xs text-gray-500 block">Opomba
          <input className={polje + ' block w-56'} value={f.opomba} onChange={e => setF({ ...f, opomba: e.target.value })} /></label>
        {!samoStalni && <label className="text-sm inline-flex items-center gap-1.5 pb-2">
          <input type="checkbox" checked={!!f.stalni} onChange={e => setF({ ...f, stalni: e.target.checked })} />Velja vsak mesec</label>}
        <button type="button" className={gumb} disabled={dela || nova !== null || !f.znesek} onClick={shrani}>Dodaj</button>
      </div>
      <Sporocilo msg={msg} />
    </div>
  );
}

function SeznamDodatkov({ cid, dodatki, urejanje, onSpremeni }: { cid: string; dodatki: any[]; urejanje: boolean; onSpremeni: () => void }) {
  const [potrdi, setPotrdi] = useState<string | null>(null);
  const [msg, setMsg] = useState<{ tip: 'ok' | 'napaka'; t: string } | null>(null);
  const brisi = async (id: string) => {
    setMsg(null);
    try { await api.delete(`/kadri/${cid}/dodatki/${id}`); setPotrdi(null); onSpremeni(); }
    catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); }
  };
  if (!dodatki.length) return <div className="text-sm text-gray-400">Ni dodatkov.</div>;
  return (
    <div className="space-y-2">
      <table className="w-full text-sm">
        <thead><tr className="text-left text-gray-500 border-b border-gray-200 dark:border-gray-700">
          <th className="py-1.5 pr-3">Vrsta</th><th className="pr-3 text-right">Znesek / ure</th><th className="pr-3">Velja</th><th className="pr-3">Opomba</th>{urejanje && <th />}</tr></thead>
        <tbody>
          {dodatki.map((x: any) => (
            <tr key={x.id} className="border-b border-gray-100 dark:border-gray-800">
              <td className="py-1.5 pr-3">{x.naziv}</td>
              <td className="pr-3 text-right">{st(x.znesek)}</td>
              <td className="pr-3">{x.stalni ? 'vsak mesec' : `${MESECI[(x.mesec || 1) - 1]} ${x.leto}`}</td>
              <td className="pr-3 text-gray-500">{x.opomba || ''}</td>
              {urejanje && <td className="text-right whitespace-nowrap">
                {potrdi === x.id
                  ? <span className="inline-flex items-center gap-2">{x.stalni ? 'Izbrišem za vse mesece?' : 'Izbrišem?'}
                      <button type="button" className="text-red-700 hover:underline" onClick={() => brisi(x.id)}>Da</button>
                      <button type="button" className="text-gray-500 hover:underline" onClick={() => setPotrdi(null)}>Ne</button></span>
                  : <button type="button" className="text-red-600 hover:underline" onClick={() => setPotrdi(x.id)}>Briši</button>}
              </td>}
            </tr>))}
        </tbody>
      </table>
      <Sporocilo msg={msg} />
    </div>
  );
}

/* »Moj mesec«: stanje ur, izplačilo nadur, dodatki meseca (stalni + ta mesec). r = odgovor /kadri/{cid}/mesec.
   [PATCH dc-stanje v1] stanje ur = prenos + razlika meseca − izplačane nadure; admin popravi prenos (npr. na 0) in izplača vse ali vpisano število ur. */
export function DodatkiMeseca({ cid, r, admin, lm, onSpremeni }: { cid: string; r: any; admin: boolean; lm: { leto: number; mesec: number }; onSpremeni: () => void }) {
  const [msg, setMsg] = useState<{ tip: 'ok' | 'napaka'; t: string } | null>(null);
  const s: any = r?.stanje || {};
  const [prenosUredi, setPrenosUredi] = useState<string | null>(null);
  const [ureIzpl, setUreIzpl] = useState<string>(s.nadure_ure != null ? String(s.nadure_ure).replace('.', ',') : '');
  const [vse, setVse] = useState<boolean>(s.nadure_ure == null);
  useEffect(() => { setUreIzpl(s.nadure_ure != null ? String(s.nadure_ure).replace('.', ',') : ''); setVse(s.nadure_ure == null); setPrenosUredi(null); },
    [s.nadure_ure, lm.leto, lm.mesec, r?.zaposleni?.id]);
  const zid: string = r?.zaposleni?.id || '';
  const zaklenjen = !!r?.zaklenjeno;
  const dodatki: any[] = r?.dodatki || [];
  const naVoljo = Number(s.na_voljo || 0);
  const pz = (v: any) => (Number(v) > 0 ? '+' : '') + st(v);
  const posli = async (pot: string, telo: any) => {
    setMsg(null);
    try { await api.post(`/kadri/${cid}/${pot}`, { zaposleni_id: zid, leto: lm.leto, mesec: lm.mesec, ...telo }); onSpremeni(); }
    catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); }
  };
  const nadure = (izplacaj: boolean, ure?: string) => posli('mesec/nadure', { izplacaj, ure: izplacaj && ure ? ure.replace(',', '.') : null });
  const prenos = (v: string | null) => posli('mesec/prenos', { prenos: v === null ? null : v.replace(',', '.') });
  return (
    <div className={kartica + ' space-y-3'}>
      <div className="text-sm font-medium">Stanje ur, nadure in dodatki</div>
      {r?.stanje && (
        <div className="flex items-center gap-x-6 gap-y-2 flex-wrap text-sm">
          <span>Prenos iz prejšnjih mesecev: <b>{pz(s.prenos)} h</b>{s.prenos_rocno && <span className="text-xs text-gray-400"> (ročno)</span>}</span>
          <span>Ta mesec: <b>{pz(s.razlika)} h</b></span>
          {Number(s.izplacilo) > 0 && <span>Izplačane nadure: <b>{st(s.izplacilo)} h</b></span>}
          <span>Stanje ob koncu meseca: <b className={Number(s.konec) < 0 ? 'text-red-600' : Number(s.konec) > 0 ? 'text-green-600' : ''}>{pz(s.konec)} h</b></span>
          {admin && !zaklenjen && prenosUredi === null &&
            <button type="button" className="text-sm text-blue-700 hover:underline" onClick={() => setPrenosUredi(String(s.prenos || '0').replace('.', ','))}>Popravi prenos</button>}
          {admin && !zaklenjen && prenosUredi !== null && <span className="inline-flex items-center gap-2">
            <input className={polje + ' w-24'} inputMode="decimal" value={prenosUredi} onChange={e => setPrenosUredi(e.target.value)} />
            <button type="button" className={gumb2} onClick={() => prenos(prenosUredi)}>Shrani</button>
            <button type="button" className={gumb2} onClick={() => prenos('0')}>Na 0</button>
            {s.prenos_rocno && <button type="button" className={gumb2} onClick={() => prenos(null)}>Uporabi izračun</button>}
            <button type="button" className="text-sm text-gray-500 hover:underline" onClick={() => setPrenosUredi(null)}>Prekliči</button></span>}
        </div>)}
      {admin && (naVoljo > 0 || s.izplacaj) && (
        <div className="flex items-center gap-3 flex-wrap text-sm">
          <label className="inline-flex items-center gap-2">
            <input type="checkbox" checked={!!s.izplacaj} disabled={zaklenjen} onChange={e => nadure(e.target.checked, vse ? undefined : ureIzpl)} />
            Izplačilo nadur</label>
          {s.izplacaj && <>
            <label className="inline-flex items-center gap-1.5"><input type="radio" checked={vse} disabled={zaklenjen} onChange={() => { setVse(true); nadure(true); }} />vse ({st(naVoljo)} h)</label>
            <label className="inline-flex items-center gap-1.5"><input type="radio" checked={!vse} disabled={zaklenjen} onChange={() => setVse(false)} />vpišem:</label>
            {!vse && <><input className={polje + ' w-24'} inputMode="decimal" value={ureIzpl} disabled={zaklenjen} onChange={e => setUreIzpl(e.target.value)} />
              <button type="button" className={gumb2} disabled={zaklenjen || !ureIzpl} onClick={() => nadure(true, ureIzpl)}>Shrani</button></>}
            <span className="text-xs text-gray-500">v plače gre {st(s.izplacilo)} h{/* [PATCH dc-stanje v2] šifro določajo Vrste plačil */}</span></>}
        </div>)}
      <Sporocilo msg={msg} />
      <SeznamDodatkov cid={cid} dodatki={dodatki} urejanje={admin && !zaklenjen} onSpremeni={onSpremeni} />
      {admin && !zaklenjen && zid && <DodatekObrazec cid={cid} zaposleniId={zid} leto={lm.leto} mesec={lm.mesec} samoStalni={false} onShranjeno={onSpremeni} />}
    </div>
  );
}

/* Šifranti → Zaposleni → zaposleni: stalni dodatki (veljajo vsak mesec). */
export function StalniDodatki({ cid, zid }: { cid: string; zid: string }) {
  const [d, setD] = useState<any>(null);
  const [msg, setMsg] = useState<{ tip: 'ok' | 'napaka'; t: string } | null>(null);
  const nalozi = useCallback(() => {
    api.get(`/kadri/${cid}/zaposleni/${zid}/dodatki`).then((r: any) => setD(r.data)).catch((e: any) => setMsg({ tip: 'napaka', t: napaka(e) }));
  }, [cid, zid]);
  useEffect(() => { nalozi(); }, [nalozi]);
  return (
    <div className="rounded-xl bg-gray-50 dark:bg-gray-800/50 p-3 space-y-3">
      <div className="text-xs font-medium text-gray-500">Stalni dodatki (veljajo vsak mesec)</div>
      <Sporocilo msg={msg} />
      {d && <SeznamDodatkov cid={cid} dodatki={d.dodatki || []} urejanje={true} onSpremeni={nalozi} />}
      <DodatekObrazec cid={cid} zaposleniId={zid} samoStalni={true} onShranjeno={nalozi} />
    </div>
  );
}

/* [PATCH dc-opal-fe v1] Šifranti → Zaposleni: Pripravljenost / Posebni pogoji dela — ure = seštevek izbranih vrst (Janez 20.10.2026).
   Brez kljukice se ure vpišejo ročno v Moj mesec (Stanje ur, nadure in dodatki); oboje se sešteje.
   API: /kadri/{cid}/zaposleni/{zid}/place-dodatki (GET, PUT). */
export function PlaceDodatkiZaposlenega({ cid, zid }: { cid: string; zid: string }) {
  const [d, setD] = useState<any>(null);
  const [n, setN] = useState<any>({});
  const [msg, setMsg] = useState<{ tip: 'ok' | 'napaka'; t: string } | null>(null);
  useEffect(() => {
    api.get(`/kadri/${cid}/zaposleni/${zid}/place-dodatki`).then((r: any) => { setD(r.data); setN(r.data.nastavitve || {}); })
      .catch((e: any) => setMsg({ tip: 'napaka', t: napaka(e) }));
  }, [cid, zid]);
  if (!d) return <Sporocilo msg={msg} />;
  const nastavi = (k: string, v: any) => setN({ ...n, [k]: { ...(n[k] || { vkljuceno: false, vrste: [] }), ...v } });
  const shrani = async () => {
    setMsg(null);
    try { const r = await api.put(`/kadri/${cid}/zaposleni/${zid}/place-dodatki`, { nastavitve: n }); setN(r.data.nastavitve || {}); setMsg({ tip: 'ok', t: 'Shranjeno' }); }
    catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); }
  };
  return (
    <div className="rounded-xl bg-gray-50 dark:bg-gray-800/50 p-3 space-y-3">
      <div className="text-xs font-medium text-gray-500">Pripravljenost in posebni pogoji dela</div>
      {(d.dodatki || []).map((x: any) => {
        const c = n[x.kljuc] || { vkljuceno: false, vrste: [] };
        return (
          <div key={x.kljuc} className="space-y-1.5">
            <label className="text-sm inline-flex items-center gap-2">
              <input type="checkbox" checked={!!c.vkljuceno}
                onChange={e => nastavi(x.kljuc, { vkljuceno: e.target.checked, vrste: e.target.checked && !(c.vrste || []).length ? ['REDNO', 'DELO_DOMA'] : c.vrste })} />
              {x.naziv}: ure = seštevek ur izbranih vrst</label>
            {c.vkljuceno && <div className="flex items-center gap-4 flex-wrap text-sm pl-6">
              {(d.vrste || []).map((v: any) => (
                <label key={v.kljuc} className="inline-flex items-center gap-1.5">
                  <input type="checkbox" checked={(c.vrste || []).includes(v.kljuc)}
                    onChange={e => nastavi(x.kljuc, { vrste: e.target.checked ? [...(c.vrste || []), v.kljuc] : (c.vrste || []).filter((y: string) => y !== v.kljuc) })} />
                  {v.naziv}</label>))}
            </div>}
          </div>);
      })}
      <div className="text-xs text-gray-500">Brez kljukice se ure vpišejo ročno v Moj mesec (Stanje ur, nadure in dodatki). Če je vpisano oboje, se ure seštejejo. V plače gre po šifri iz Vrst plačil.</div>
      <Sporocilo msg={msg} />
      <button type="button" className={gumb} onClick={shrani}>Shrani</button>
    </div>
  );
}
